import { tsValidateNumber, tsValidateUniqueId } from '@nu-art/ts-common';
import { accountGroupName } from '../session/index.js';
const Validator_ModifiableProps = {
    count: tsValidateNumber(),
    accountId: tsValidateUniqueId,
    loginSuccessfulAt: tsValidateNumber(false)
};
const Validator_GeneratedProps = {};
export const DBDef_FailedLoginAttempt = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'failed-login-attempt',
    entityName: 'failed-login-attempt',
    frontend: {
        group: accountGroupName,
        name: 'failed-login-attempt'
    },
    backend: {
        name: 'user-account--failed-login-attempt'
    }
};
//# sourceMappingURL=db-def.js.map